import React from 'react';
import Banner from 'ui/Banner/Banner';
import Raw from 'ui/Raw/Raw';
import ImgBlock from 'ui/ImgBlock/ImgBlock';
import CultureDefs from './CultureDefs';

const Culture = ({title, body, bgImageUrl, images, leading, items}) => {
    return (
        <section id="careers-culture" className="careers-culture">
            <Banner image={bgImageUrl}>
                <h2 className="text-white">{title}</h2>
                <Raw content={body} className="text-constrained" />
            </Banner>
            <div className="container container--overlap">
                <ImgBlock images={images} />
                <div className="container">
                    <CultureDefs />
                    <h2 className="leading">{leading}</h2>
                    <div className="culture-row">
                        {items &&
                            items.map((item, i) => (
                                <div
                                    className="career-aspect"
                                    key={`culture-${i}`}
                                >
                                    <div className="culture-svg ">
                                        <svg className="inline-svg">
                                            <use
                                                xlinkHref={`#culture-${
                                                    item.name
                                                }`}
                                            />
                                        </svg>
                                    </div>
                                    <div className="culture-description">
                                        <h4>{item.title}</h4>
                                        <p>{item.body}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Culture;
